import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';

export type UserDeleteData = AnyObject;

export type UserDeleteResponse = UserDeleteData;

export interface UserDelete {
  id: string;
}

export const userDelete = (payload: UserDelete): Action<UserDelete> => ({
  type: actions.userDeleteTrigger.toString(),
  payload,
});

export const userDeleteClear = (): Action => ({
  type: actions.userDeleteClear.toString(),
});

export const userDeleteErrorClear = (): Action => ({
  type: actions.userDeleteErrorReset.toString(),
});

export function* userDeleteRequestSaga({ payload }: Action<UserDelete>) {
  yield put({
    type: actions.userDeleteStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.userDeleteError.toString(),
      payload: {
        message: 'UserDelete: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/users/${id}`,
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<UserDeleteData, UserDeleteResponse>(
    response,
    actions.userDeleteSuccess.toString(),
    actions.userDeleteError.toString(),
    false,
    (userDeleteData) => userDeleteData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.userDeleteTrigger.toString(),
    defaultProcessingSaga(
      userDeleteRequestSaga,
      {
        error: actions.userDeleteError.toString(),
        locationCancel: actions.userDeleteClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.userDeleteSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.userDeleteClear.toString(),
    // });
  });

  yield takeLatest(actions.userDeleteError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.userDeleteErrorReset.toString(),
    });
  });
}
